var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"informationList"},_vm._l((_vm.NewsList),function(news){return _c('li',{key:news.id,on:{"click":function($event){return _vm.newDetail(news.id)}}},[_vm._v(_vm._s(news.title))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }